import { t } from "@/i18n-js/instance";
import { FormTipTapEditor } from "@circle-react-shared/Emails/VisualEmailBuilder/EditorFields/RichTextField/FormTiptapEditor";
import { Form } from "@circle-react-uikit/Form";

export const Text = () => (
  <div className="py-3 pb-5">
    <Form.Item
      name="text"
      label={t("builder_ui.prop_type.text")}
      hideDescription
      hideBorder
      labelClassName="text-dark text-xs font-normal"
      className="!p-0"
    >
      <FormTipTapEditor name="text" />
    </Form.Item>
  </div>
);
